
class exports.PopulationTab extends Handler

    init: () ->
        # don't call loadLayout() because the HTML is already loaded

        self = this
        sidebar = $(@layoutSelector)

        @subHandlers =
            'Population':
                'class': 'portal::handlers/weightings/PopulationDialog'

        @taffyObjects = @parent.taffyObjects


        # placement program dropdown
        sidebar.find('#sel_pop_pp').on 'change', () =>
            @toggleProdZoneWarning()

            sub = @createSubHandler 'Population'
            if sub
                sub.loadLayoutPostOptions =
                    pp_id: sidebar.find('#sel_pop_pp').val()
                sub.init()

        sidebar.find('#sel_pop_pp').trigger 'change'

        @toggleProdZoneWarning()


    toggleProdZoneWarning: () ->
        sidebar = $(@layoutSelector)
        pp_id = parseInt sidebar.find('#sel_pop_pp').val()

        if pp_id
            pw = @taffyObjects.pw(placement_programs_id: pp_id).first()

            if pw.enable_grower_ranges
                sidebar.find('#prod_zone_warning').hide()
            else
                sidebar.find('#prod_zone_warning').show()


    destroy: () ->
        super false
